import { useEffect } from 'react';

/**
 * Auto-syncs Country + Currency state on the Quote Calculator from the
 * authenticated user's saved profile. AuthContext hydrates async after
 * mount, so the initial useState fallback ("United States" / USD) may
 * race with the user load. This hook resolves that race once the user
 * arrives, and re-applies whenever the user's saved country changes
 * (e.g., they updated AccountSettings in another tab).
 *
 * UX guarantee: a manual dropdown change (countryUserSet / currencyUserSet
 * = true) suppresses the auto-sync so we never clobber an explicit choice
 * the customer just made on this page.
 *
 * Extracted from the QuoteCalculator page body to slim that file down.
 */
export const useCountryCurrencyAutoSync = ({
  user,
  countryUserSet,
  currencyUserSet,
  setCountry,
  setCurrency,
}) => {
  // Currency: CAD for Canadians, USD for everyone else.
  useEffect(() => {
    if (currencyUserSet) return;
    if (!user?.country) return;
    const auto = user.country === 'Canada' ? 'CAD' : 'USD';
    setCurrency((prev) => (prev === auto ? prev : auto));
  }, [user?.country, currencyUserSet, setCurrency]);

  // Shipping country: mirror the user's saved value.
  useEffect(() => {
    if (countryUserSet) return;
    if (!user?.country) return;
    setCountry((prev) => (prev === user.country ? prev : user.country));
  }, [user?.country, countryUserSet, setCountry]);
};

export default useCountryCurrencyAutoSync;
